import formattedParams from '../../common/configOfferParams.js';
import offerCategories from '../../common/offerCategories.js';

export const formatNumber = (
    val, isCompact, whenIsCompact,
) => {
    const options = isCompact
        && val.length >= whenIsCompact
        ? { notation: 'compact' } : {};
    return new Intl.NumberFormat('ru', options).format(val);
};

const isNumber = str => typeof Number(str) === 'number' && !Number.isNaN(Number(str));

function getParam(field, obj) {
    if (!obj) {
        return {};
    }
    return {
        name: obj.label,
        [obj.pKey]: field.value,
        key: obj.key,
    };
}

/* eslint-disable no-param-reassign */
function setParam(param, categoryIds) {
    if (param.key === 'amount' && categoryIds.includes(offerCategories.MORTGAGE)) {
        if (param.end && isNumber(param.end)) {
            param.end = formatNumber(
                param.end,
                true,
                7,
            ).toUpperCase();
        }
    } else {
        if (param.start && isNumber(param.start)) {
            param.start = formatNumber(
                param.start,
                true,
                7,
            ).toUpperCase();
        }
        if (param.end && isNumber(param.end)) {
            param.end = formatNumber(
                param.end,
                true,
                7,
            ).toUpperCase();
        }
    }
    if (['income', 'creditLimit'].includes(param.key)) {
        if (param.single && isNumber(param.single)) {
            param.single = formatNumber(
                param.single,
                true,
                7,
            ).toUpperCase();
        }
    }
    if (param.start && param.end) {
        param.string = `${param.start} - ${param.end}`;
        param.range = true;
    } else if (param.start) {
        param.string = 'от ' + param.start;
    } else if (param.end) {
        param.string = 'до ' + param.end;
    } else {
        param.string = param.single;
    }
}

// eslint-disable-next-line import/prefer-default-export
export function createParams(offers) {
    return offers.map(offer => {
        if (offer.offerCategories) {
            offer.offerCategories = offer.offerCategories.map(id => id.toString());
        }

        offer.params = {};
        offer.params.approval = {
            key: 'approval',
            name: '',
            single: '',
            string: '',
        };

        offer.fields
            .filter(field => field.value.trim() && field.visible)
            .map(field => {
                const param = getParam(field, formattedParams[field.key]);
                offer.params[param.key] = {
                    ...(offer.params[param.key] || {}),
                    ...param,
                };
                const p = offer.params[param.key];
                setParam(p, offer.offerCategories);
                return field;
            });
        return offer;
    });
}
